<template>
  <div class="dropdownContainer">
    <div
      class="dropdown"
      :class="{ dropdownOpen: open }"
      v-click-outside="onClickOutside"
    >
      <div class="inputContainer">
        <!-- v-model doesn't work on android, so there is should be :value and @input-->
        <input
          class="input"
          @focus="open = true"
          :name="name"
          required
          ref="input"
          :value="inputValue"
          @input="onInput"
          v-on:keyup.13="toggleDropdown"
          :disabled="disabled"
        />
        <label class="label">{{ placeholder }}</label>
      </div>
      <img
        v-if="!disabled"
        class="inputIcon"
        :src="
          require(`@/assets/icons/icons-arrow-${open ? 'up-dark' : 'down'}.svg`)
        "
        @click="toggleDropdown"
      />
      <img
        class="inputIcon onMobile"
        :src="require(`@/assets/icons/icons-${open ? 'cross' : 'list'}.svg`)"
        @click="toggleDropdown"
      />
      <div class="listContainer" v-if="open">
        <div class="suggestionsContainer">
          <p
            class="listItem"
            :class="{ active: pickedItem && pickedItem === item }"
            :key="item"
            v-for="item in filteredList"
            @click="pickItem(item)"
            @click.stop
          >
            {{ item }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clickOutside } from '../helpers/directives';
import semver from 'semver';

export default {
  name: 'dropdown',
  props: {
    placeholder: { type: String },
    name: { type: String },
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    value: { type: String }
  },
  directives: {
    clickOutside
  },
  data() {
    return {
      open: false,
      inputValue: '',
      isInputting: false,
      pickedItem: null
    };
  },
  methods: {
    onClickOutside() {
      this.open = false;
    },
    pickItem(item) {
      this.pickedItem = item;
      this.isInputting = false;
      if (item === null) {
        this.inputValue = '';
        this.$emit('input', null);
      } else {
        this.inputValue = item || '';
        if (item) this.$emit('input', item);
      }
      this.open = false;
    },
    toggleDropdown() {
      if (this.disabled) {
        this.open = false;
        this.$emit('input', this.inputValue);
        return;
      }

      this.open = !this.open;
      if (this.open) {
        this.$refs.input.focus();
      }
    },
    onInput($event) {
      this.inputValue = $event.target.value;
      this.pickedItem = null;
      this.$emit('input', this.inputValue);
      if (!this.isInputting) this.isInputting = true;
    }
  },
  computed: {
    filteredList() {
      let list = this.list;
      if (this.isInputting && this.inputValue)
        list = list.filter(item => {
          return item.indexOf(this.inputValue) >= 0;
        });

      list.sort((a, b) => semver.gt(a, b));

      return list;
    }
  },
  watch: {
    open(open) {
      if (!open && this.pickedItem) this.inputValue = this.pickedItem;

      this.$emit(open ? 'open' : 'close');
    },
    value(val) {
      this.inputValue = val;
      this.pickedItem = val;
    }
  }
};
</script>

<style lang="scss">
.inputContainer {
  position: relative;
  font-size: 1rem;

  .input {
    transition: 0.2s;

    &:valid ~ .label,
    &:disabled ~ .label {
      transform: translateY(-15px);
      font-size: 0.625rem;
      opacity: 0;
    }

    &:focus ~ .label {
      transform: translateY(-15px);
      font-size: 0.625rem;
      opacity: 1;
    }
  }

  .label {
    position: absolute;
    color: #737a82;
    left: 1rem;
    top: 0.5rem;
    pointer-events: none;
    transition: 0.3s;
  }
}

.input {
  height: calc(2.25rem + 2px);
  width: 100%;
  margin-bottom: 1rem;
  padding: 1rem;
  outline: none;
  box-sizing: border-box;

  font-size: 0.875rem;
  letter-spacing: 0.5px;

  border: 1px solid #ced4da;
  border-radius: 0.25rem;

  &:hover:not(:disabled) {
    border-color: grey;
  }

  &:focus {
    border: 0;
    border-bottom: 2px solid white;
    padding-bottom: 0.5rem;
  }

  &::placeholder {
    color: #ced4da;
  }

  &.input-danger {
    border-color: red;
  }
}

.inputIcon {
  position: absolute;
  right: 0.625rem;
  top: 0;
  cursor: pointer;
}

.dropdownContainer {
  position: relative;
  width: 100%;
  height: 3rem;
  margin: 0;

  .dropdown {
    box-sizing: border-box;

    & .input {
      font-size: 0.875rem;
      letter-spacing: 0.6px;
      cursor: pointer;

      &:disabled {
        cursor: default;
      }

      &::placeholder {
        text-transform: capitalize;
      }
    }

    .onMobile {
      display: none;
    }

    &.dropdownOpen {
      position: absolute;
      width: 100%;
      margin-top: 0;
      margin-left: 0;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);

      background-color: white;
      z-index: 100;

      .inputContainer {
        margin: 1rem;
      }

      & .input {
        z-index: 101;

        border: 0;
        border-bottom: 2px solid white;
        width: 100%;
      }

      & .inputIcon {
        top: 0;
        right: 0.625rem;
      }
    }

    .listContainer {
      .suggestionsContainer {
        max-height: 15rem;
        overflow-y: auto;
      }

      .listItem {
        font-size: 1rem;
        line-height: 2.75rem;
        letter-spacing: 0.5px;
        color: black;
        margin: 0;
        padding: 0 1.5rem;
        cursor: pointer;

        &:hover {
          background-color: white;
        }

        &.active {
          font-weight: bold;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .dropdownContainer {
    .dropdown {
      .inputIcon {
        display: none;

        &.onMobile {
          display: block;
        }
      }

      .listContainer {
        .suggestionsContainer {
          @media (orientation: portrait) {
            height: 60vh;
          }
        }
      }
    }
  }
}
</style>
